<template>
  <div></div>
</template>

<script>
import hubspotApi from "@/api/hubspot"
import { mapGetters } from "vuex"

/**
 * Authenticate OAuth client and redirect.
 */
export default {
  // calculated props
  computed: {
    // spread getters
    ...mapGetters({
      jwt: "auth/getIdToken"
    })
  },

  /**
   * Process code
   */
  mounted() {
    this.processCode()
  },

  // component functions
  methods: {
    /**
     * Process code
     */
    processCode() {
      this.handleOAuth(this.$route.query.code)

      this.$nextTick(() => {
        this.$router.push("/")
      })
    },

    /**
     * handle oauth
     */
    async handleOAuth(code) {
      // init api
      const api = hubspotApi("NONE_API", this.jwt)

      return await api.notify("set_code", { code })
    }
  }
}
</script>
